module.exports = __webpack_public_path__ + "static/numbers-4-1-6fc0f0a9ac71b848ecc2ebc57e03a754.png";